import axiosApi from '../../utilities/axiosApi';

export function getVisitTrackingInfo() {
	const requestUrl = '/api/VisitTracking/GetVisitTrackingInfo';
	
	const config = {
		headers: { 'WelcomeApp_Referrer': document.referrer, 'WelcomeApp_URL': document.URL}};
	return axiosApi.getEndpoint(requestUrl, config).then(response => {
		return response;
	}).catch(error => {
		throw error;
	});
}